import React from 'react';
import { Link } from 'react-router-dom';
// import profile from "../assets/profile.png";
import { Col } from 'antd';
import { useCookies } from 'react-cookie';
import ProfileImage from './ProfileImage';

const Sidebar = () => {
    // eslint-disable-next-line no-unused-vars
    const [cookies, removeCookie] = useCookies(['SESSION']);

    const logout = () => {
        removeCookie('SESSION', {
            path: '/',
        });
    };

    return (
        <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 6 }}
            lg={{ span: 6 }}
            xl={{ span: 6 }}
            xxl={{ span: 6 }}
            className="search-left"
        >
            {/* <img src={profile} className="profileContainerImg" alt="profile" /> */}
            <ProfileImage allowedEdit={true} />
            <br />

            <Link className="profileContainerMenu" to={'/profile/detail'}>
                Profile
            </Link>

            <Link
                className="profileContainerMenu"
                to={{
                    pathname: '/subscriptions',
                    search: '?status=current',
                }}
            >
                Current Subscritpion
            </Link>

            <Link
                className="profileContainerMenu"
                to={{
                    pathname: '/subscriptions',
                    search: '?status=history',
                }}
            >
                Subscritpion History
            </Link>
            <Link
                className="profileContainerMenu"
                to={{
                    pathname: 'subscriptions',
                    search: '?status=change-password',
                }}
            >
                Change Password
            </Link>
            <br />
            <input className="profileLogout" type="submit" value="Logout" onClick={() => logout()} />
        </Col>
    );
};

export default Sidebar;
